import styled from "styled-components";

export const BottomDiv=styled.div`
    display: ${({isDesktop}) => (isDesktop ? "none" : "flex")}; !important;
      width: 100%;
      position: fixed;
      bottom: 0px;
      padding: 15px 10px 10px;
      background-color: ${({nobg}) => (nobg ? "unset":"white")};      // added for mobile responsive
      justify-content: space-between;
      align-items: end;
      z-index:11;
      border-top: ${({nobg}) => (nobg ? "unset":"1px solid rgba(230, 230, 230, 1);")};
      box-shadow: 3px 3px 3px #333;
`;

export const StationNameHeader=styled.div`
    display:none;
    @media screen and (max-width: 850px){
        display: ${({show}) => (show ? "flex" : "none")};
        width: 100%;
        position: fixed;
        top: 58px;
        padding-bottom: 5px;
        background-color: white ;
        align-items: center;
        z-index:10;
        justify-content: center;
        font-family: Lato;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        text-align: left;
    }
`

export const BottomIcon=styled.img`
    display: none;
    width: 38px;
    height: 38px;
    color: #fff; 
    margin-left: auto;
`;